/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OtaUpgVersionInfo } from 'app/common/types/mo';
import { type Progress } from 'app/feature/share/header-settings/upgrade/upgrade.const';

/**
 * OTA包下载进度
 */
export interface OtaPkgDownloadProgress {
    /**
     * 剩余时间
     */
    remainTime?: string;
    /**
     * 进度 0~100
     */
    progress?: number;
    /**
     * 详细细节
     */
    detail?: string;
    /**
     * 状态
     */
    status?: DownloadStatusE;
}

export interface EvaluateStorageStatus {
    currentProcess: Progress;
    evaluateTime: string;
    versionsJson: OtaUpgVersionInfo;
}

export interface DownloadInIdleTime {
    switch?: 'true' | 'false';
    offPeakStartTime?: string;
    offPeakEndTime?: string;
    maxSpeed?: string;
}

export interface AutoUpgradeSwitch {
    upgSwitch?: boolean;
}
export interface AutoUpgradeSwitchGet {
    upgSwitch?: 'true' | 'false';
}

/**
 * 包类型
 */
export enum PackageTypeE {
    /**
     * 系统大包
     */
    SYS_PKG = 1,
    /**
     * 热补丁包
     */
    HOT_PATCH_PKG = 3,
    /**
     * 升级中打补丁
     */
    HOT_PATCH_IN_UPD = 7,
    /**
     * 检查项包
     */
    UPG_CHECK_PKG = 8
}

export enum EvaluateStateE {
    success = 0,
    fail = 1
}

/**
 * 下载状态
 */
export enum DownloadStatusE {
    Init = 0,
    Downloading = 1,
    Pause = 2,
    Failed = 3,
    Success = 4,
    // 自定义的信息获取失败状态
    GetInfoFailed = 9
}


/**
 * 下载动作类型
 */
export enum DownloadStartTypeE {
    Start = 0,
    Sequel = 1,
    Pause = 2,
    Cancel = 3,
    Delete = 4
}

/**
 * Ota升级轮询周期
 */
export enum OtaPollingPeriod {
    /**
     * 默认10秒
     */
    Default = 10000,
    /**
     * 下载5秒
     */
    Download = 5000
}

/**
 * 轮询接口失败允许的报错次数
 */
export enum PoolingExceptionTime {
    /**
     * 默认3次，即连续4次报错将做处理
     */
    Default = 3
}
